export const EMAIL_REGEXP_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
//# sourceMappingURL=validations.js.map